class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.enablePage = this.dataset.enablePage || '';
    this.wrapper = this.closest('.bls-section-newsletter-popup');
    this.cookieKey = 'ce_popup_seen';
    this.cookieDays = 7;
    this.delayMs = 10000;
    this.shown = false;
  }

  connectedCallback() {
    if (!this.wrapper) return;
    if (!this._shouldRunOnThisPage()) return;
    if (this._hasCookie()) return;

    this._delayTimer = window.setTimeout(() => this._show('delay'), this.delayMs);
    document.documentElement.addEventListener('pointerleave', this._onExitIntent, { once: false });
    window.addEventListener('pagehide', () => this._cleanup());
  }

  _shouldRunOnThisPage() {
    if (this.enablePage === 'show-all-page') return true;
    if (this.enablePage === 'show-on-homepage') {
      return document.body.classList.contains('template-index');
    }
    return false;
  }

  _onExitIntent = (event) => {
    if (this.shown) return;
    if (event.clientY > 0) return;
    this._show('exit');
  };

  _show(source) {
    if (this.shown) return;
    this.shown = true;
    this.wrapper.style.display = 'flex';
    this.wrapper.classList.add('is-visible');
    document.body.classList.add('ce-popup-open');
    this._setCookie();
    this._bindClosers();
  }

  _bindClosers() {
    const dismiss = this.querySelector('.bls-newsletter-popup__dont-show');
    if (dismiss) dismiss.addEventListener('click', () => this._close());
    this.wrapper.addEventListener('click', (e) => {
      if (e.target === this.wrapper) this._close();
    });
    document.addEventListener('keydown', this._onKey);
  }

  _onKey = (e) => {
    if (e.key === 'Escape') this._close();
  };

  _close() {
    this.wrapper.classList.remove('is-visible');
    this.wrapper.style.display = 'none';
    document.body.classList.remove('ce-popup-open');
    document.removeEventListener('keydown', this._onKey);
  }

  _setCookie() {
    const d = new Date();
    d.setTime(d.getTime() + this.cookieDays * 24 * 60 * 60 * 1000);
    document.cookie = `${this.cookieKey}=1; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }

  _hasCookie() {
    return document.cookie.split('; ').some((c) => c.startsWith(`${this.cookieKey}=`));
  }

  _cleanup() {
    if (this._delayTimer) window.clearTimeout(this._delayTimer);
    document.documentElement.removeEventListener('pointerleave', this._onExitIntent);
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
